


















































import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'
import {MediaObject} from '@/modules/media/types'
import {Mutation, State} from 'vuex-class'
import {Colors, notify} from '@/modules/core/notification'

/**
 * Elemento de la librería multimedia
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class MediaLibraryItem extends Vue {
    /**
     * Indica si el componente debe mostrarse como la fila de una tabla
     */
    @Prop({type: Boolean, default: false})
    public row: boolean

    @Prop({type: Boolean, default: false})
    public multiselect: boolean

    // @Prop({type: Boolean, default: false})
    // public selected: boolean

    /**
     * Objeto multimedia mostrado por el componente
     */
    @Prop({type: MediaObject, default: () => new MediaObject()})
    public value: MediaObject

    @State(state => state.media.selectedObjects)
    public selectedObjects: number[]

    /**
     * Activa o desactiva el visor multimedia
     */
    @Mutation('media/viewer/show')
    public showMediaViewer: (show: boolean) => void

    /**
     * Establece el objeto multimedia actual
     */
    @Mutation('media/objects/current/set')
    public setCurrentMediaObject: (media: MediaObject) => void

    @Mutation('media/SET_SELECTED_OBJECTS')
    public setSelectedObjects: (selected: number[]) => void

    public readonly id = _.uniqueId('media_item_')
    public clicks = 0

    public get thumbnail (): string {
        const url = this.value.thumbnail('medium')
        return url ? `${url}?t=${this.value.updateAt.getTime() / 1000}` : ''
    }

    public selectMedia (media: MediaObject) {
        if (!media.mediaFound) {
            notify('El archivo no se encuentra disponible en el servidor', Colors.Error, {
                notShowInCenter: true,
            })
            return
        }

        this.setCurrentMediaObject(media)
        // this.showMediaViewer(true)

        this.$router.push({
            name: 'media.library.viewer',
            params: { id: media.id.toString( )},
        })
    }

    public get selected () {
        return this.$store.getters['media/itemIsSelected'](this.value.id)
    }

    public onClick () {
        // Cuando la aplicación se muestra en un móvil, se deshabilitan el doble click,
        // el elemento es seleccionado al pulsar sobre el
        if (this.isMobile) {
            this.setSelectedObjects([this.value.id])
            this.selectMedia(this.value)

            return
        }

        this.clicks++
        if (this.clicks >= 2) {
            // Es la segunda que vez que el usuario hace click sobre el elemento,
            // se activa la pantalla del visor
            this.selectMedia(this.value)
        } else {
            if (this.isOnlySelected) {
                this.setSelectedObjects([])
            }

            if (this.multiselect) {
                this.setSelectedObjects([...this.selectedObjects, this.value.id])
            } else {
                this.setSelectedObjects([this.value.id])
            }
        }


        _.delay(() => this.clicks = 0, 300)
    }

    /**
     * Indica si este elemento es el único seleccionado
     */
    public get isOnlySelected () {
        return this.selectedObjects.length === 1
            && this.selectedObjects[0] === this.value.id
    }

    public get isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
    }

    /**
     * Retorna el identificador del objeto multimedia
     */
    public get mediaId () {
        return this.value.id
    }

    public get icon () {
        switch (true) {
            case !this.value.mediaFound:
                return 'mdi-file-alert'
            case this.value.isImage:
                return 'photo'
            case this.value.isPDF:
                return 'mdi-file-outline'
            case this.value.isVideo:
                return 'mdi-video'
            default:
                return 'mdi-file'
        }
    }

    public get thumbnailIcon  () {
        switch (true) {
            case !this.value.mediaFound:
                return 'mdi-file-alert-outline'
            case this.value.isPDF:
                return 'mdi-file-pdf-box'
            case this.value.isVideo:
                return 'mdi-video'
            default:
                return 'mdi-file'
        }
    }

    public fancyDate (date: Date) {
        const m = moment(date)
        if (!m.isValid()) {
            return 'No disponible'
        }

        return m.format('LLL')
    }
}
